import { ReactElement } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

export const HorizontalTabs = ({
  tabs,
  selectedTab = 0,
  handleChange,
}: {
  tabs: { label: string; component: ReactElement }[];
  selectedTab: number;
  handleChange: (_event: React.SyntheticEvent, newValue: number) => void;
}) => {
  return (
    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '&& .MuiTab-root': {
            textTransform: 'none',
            margin: 0,
          },
          borderBottom: 2,
          borderColor: 'divider',
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ padding: 0, height: '100%' }}>
        {tabs[selectedTab].component}
      </Box>
    </Box>
  );
};
